module.exports = __webpack_public_path__ + "img/shop.9f9d2b6b.svg";